import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textarea } from './../../models/editors/textarea.model';
import { Gdpr } from './../../models/settings/gdpr.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-gdpr',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class GdprComponent extends InlineFormBase<Gdpr> implements OnInit {
  public headerTitle = 'GDPR nastavení';

  public url = 'gdpr';

  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'disclaimer',
        label: 'GDPR prohlášení',
        validators: [Validators.required],
        isMultilang: true,
        wysiwyg: 'gdpr',
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }
}
